// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UH2T3","left":"styles_left__NWYQQ","desktopActions":"styles_desktopActions__1M8wH","title":"styles_title__2l-Aw"};